import { render, staticRenderFns } from "./PuestosTrabajo.vue?vue&type=template&id=7056f30f&"
import script from "./PuestosTrabajo.vue?vue&type=script&lang=js&"
export * from "./PuestosTrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports